import { Error } from './components/Error'
import { ErrorBoundary } from './components/ErrorBoundary'
import { FormHero } from './components/FormHero'

import { Pending } from './components/Pending'
import { Report } from './components/Report'
import { useAppState } from './hooks/useAppState'

function App() {
  const status = useAppState((s) => s.status)

  return (
    <div className='slqs-widget hero'>
      <div className='app'>
        <ErrorBoundary>
          {status === 'intake' && <FormHero />}
          {status === 'pending' && <Pending />}
          {status === 'error' && <Error />}
          {status === 'complete' && <Report />}
        </ErrorBoundary>
      </div>
    </div>
  )
}

export default App
